import { lazy } from 'react';
/** Открывает список продуктов */
export const ProductsPageAsync = lazy(() => import('./Products/ProductsPage'));